export default __webpack_public_path__ + "static/media/shieldofbrilliance.2f861b2f.png";